import { AxiosResponse } from "axios";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/device_update/force_update_check";

export class ForceUpdateCheckCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: ForceUpdateCheckReqData;

    constructor(payload: ForceUpdateCheckReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<AxiosResponse> {
        var res = await this.executeCommand(this.payload);
        return res;
    }
}

export class ForceUpdateCheckReqData {
    devices: Array<string>;

    constructor(devices: Array<string>) {
        this.devices = devices;
    }
}
